const apply = {
  // HeroSection - title and lead
  'apply.hero.title': '申込フォーム',
  'apply.hero.lead': '以下のフォームより、受講のお申込みを承ります。必要事項をご入力のうえ、内容確認へお進みください。執事になるには、日本の執事学校・執事養成学校である日本執事アカデミーでの学びが第一歩です。',

  // HeroSection
  'apply.hero.homeLink': 'ホーム',
  'apply.hero.admissionLink': '入学案内',
  'apply.hero.currentPage': '申込フォーム',
  'apply.hero.imgAlt': '申込書を両手で受け取り丁寧にお辞儀する執事の様子',

  // breadcrumb
  'apply.breadcrumb.home': 'ホーム',
  'apply.breadcrumb.admission': '入学案内',
  'apply.breadcrumb.current': '申込フォーム',

  // PreCheckSection
  'apply.precheck.label': 'BEFORE YOU APPLY',
  'apply.precheck.title': 'お申込み前のご確認',
  'apply.precheck.titleEn': 'Please Confirm',
  'apply.precheck.lead': 'お申込みの前に、いくつかの基本事項をご確認ください。詳しい応募資格や申込手順については、',
  'apply.precheck.applicationLink': '応募資格・申込の流れ',
  'apply.precheck.leadSuffix': 'のページをご覧ください。',

  // PreCheckSection items
  'apply.preCheck.item.0.label': '18歳以上（高校生不可）',
  'apply.preCheck.item.0.desc': '年齢の下限を除き、国籍・性別・経験は一切問いません。',
  'apply.preCheck.item.1.label': '先着順（定員6名）',
  'apply.preCheck.item.1.desc': '各開校日の定員は6名です。定員に達し次第、締め切ります。',
  'apply.preCheck.item.2.label': '銀行振込・一括払いのみ',
  'apply.preCheck.item.2.desc': '分割払い・クレジットカードには対応しておりません。',
  'apply.preCheck.item.3.label': '申込締切は開校14日前',
  'apply.preCheck.item.3.desc': '最少催行人数は3名。未達時は全額返金または次期振替（5%優待）を承ります。',

  // ApplicationForm
  'apply.form.label': 'APPLICATION FORM',
  'apply.form.title': '受講お申込みフォーム',
  'apply.form.titleEn': 'Course Application',
  'apply.form.requiredNote': 'の付いた項目は必ずご入力ください。入力後、確認画面へお進みいただけます。',
  'apply.form.requiredBadge': '必須',
  'apply.form.optionalBadge': '任意',
  'apply.form.altContact': 'フォームのほか、お電話',
  'apply.form.altContactHours': '（平日10:00〜17:00）またはメール',
  'apply.form.altContactSuffix': 'でもご相談を承ります。',
  'apply.form.nameLabel': '氏名',
  'apply.form.furiganaLabel': 'ふりがな',
  'apply.form.emailLabel': 'メールアドレス',
  'apply.form.phoneLabel': '電話番号',
  'apply.form.courseLabel': '希望コース',
  'apply.form.termLabel': '希望開校時期',
  'apply.form.termPlaceholder': '選択してください',
  'apply.form.transferLabel': '編入優遇の利用',
  'apply.form.transferNote': '※該当者のみ選択してください。詳しくは',
  'apply.form.transferNoteLink': 'コース一覧',
  'apply.form.transferNoteSuffix': 'をご参照ください。',
  'apply.form.motivationLabel': '受講動機',
  'apply.form.namePlaceholder': '例: 執事 太郎',
  'apply.form.furiganaPlaceholder': '例: しつじ たろう',
  'apply.form.phonePlaceholder': '例: 090-1234-5678',
  'apply.form.emailPlaceholder': '例: taro@example.com',
  'apply.form.course.essential': 'エッセンシャルコース',
  'apply.form.course.advanced': 'アドバンスコース',
  'apply.form.course.master': 'マスターコース',
  'apply.form.motivationPlaceholder': 'どのようなきっかけで当アカデミーをお知りになりましたか。また受講をお考えになった理由などがございましたら、自由にご記入ください。',
  'apply.form.consultLabel': '個別相談の希望',
  'apply.form.consultYes': '希望する',
  'apply.form.consultNo': '希望しない',
  'apply.form.privacyLabel': 'に同意します',
  'apply.form.privacyLink': 'プライバシーポリシー',
  'apply.form.submitBtn': '確認画面へ進む',

  // Validation messages
  'apply.form.error.name': '氏名は必須です',
  'apply.form.error.furigana': 'ふりがなは必須です',
  'apply.form.error.emailRequired': 'メールアドレスは必須です',
  'apply.form.error.emailInvalid': '有効なメールアドレスを入力してください',
  'apply.form.error.phone': '電話番号は必須です',
  'apply.form.error.course': '希望コースをお選びください',
  'apply.form.error.consultation': '個別相談の希望をお選びください',
  'apply.form.error.motivation': '500文字以内で入力してください',
  'apply.form.error.privacy': 'プライバシーポリシーへの同意が必要です',

  // PostSubmitGuide
  'apply.post.label': 'AFTER SUBMISSION',
  'apply.post.title': '送信後のご案内',
  'apply.post.titleEn': 'What Happens Next',
  'apply.post.lead': 'フォームのご送信後、担当者より2営業日以内にご連絡し、受講契約とお支払い（銀行振込）のご案内をお送りします。お振込みの確認をもって、受講が確定となります。',
  'apply.post.step1.num': '01',
  'apply.post.step1.title': '自動返信メール',
  'apply.post.step1.desc': 'ご入力いただいたメールアドレスに、受付確認の自動返信メールをお送りします。',
  'apply.post.step2.num': '02',
  'apply.post.step2.title': '担当者よりご連絡',
  'apply.post.step2.desc': '2営業日以内に担当者よりご連絡し、受講契約のご案内とお支払い方法をお伝えします。',
  'apply.post.step3.num': '03',
  'apply.post.step3.title': '受講確定',
  'apply.post.step3.desc': '銀行振込でのお支払い確認後、正式に受講が確定し、開校日のご案内をお送りします。',

  // AlternativeContact
  'apply.altContact.label': 'OTHER WAYS',
  'apply.altContact.title': 'フォーム以外のお申込み方法',
  'apply.altContact.titleEn': 'Alternative Contact Methods',
  'apply.altContact.lead': 'オンラインフォームのほか、お電話やメールでもお申込みに関するご相談を承っております。',
  'apply.altContact.phone.title': 'お電話',
  'apply.altContact.phone.hours': '受付時間: 平日 10:00〜17:00',
  'apply.altContact.email.title': 'メール',
  'apply.altContact.email.hours': '24時間受付（返信は平日営業時間内）',
  'apply.altContact.note': '※お電話・メールでもご相談を承りますが、正式なお申込みはフォームのご提出をお願いしております。',

  // Course comparison link
  'apply.courseCompare': 'コースを比較する',

  // FAQSection
  'apply.faq.label': 'FAQ',
  'apply.faq.title': 'よくあるご質問',
  'apply.faq.titleEn': 'Frequently Asked Questions',
  'apply.faq.contactNote': 'その他のご質問は',
  'apply.faq.contactLink': 'お問い合わせ',
  'apply.faq.contactSuffix': 'よりお寄せください',

  // FAQ items
  'apply.faq.0.question': '申込後の流れは?',
  'apply.faq.0.answer': '送信後2営業日以内にご連絡し、受講契約とお支払い（銀行振込）のご案内をお送りします。お振込み確認後に受講確定です。',
  'apply.faq.1.question': '申込を取り消せますか?',
  'apply.faq.1.answer': '所定の期間内であればキャンセルを承ります。条件は受講契約時にご案内します。',
  'apply.faq.2.question': '電話でも申し込めますか?',
  'apply.faq.2.answer': 'お電話（平日10:00〜17:00）でもご相談を承りますが、正式なお申込みはフォームのご提出をお願いしています。',

  // RelatedPages
  'apply.related.label': 'LEARN MORE',
  'apply.related.title': '関連ページ',
  'apply.related.titleEn': 'Explore Further',
  'apply.related.arrowLabel': '詳しく見る',

  // Related pages items
  'apply.related.item.0.title': '応募資格・申込の流れ',
  'apply.related.item.0.desc': '資格と申込手順',
  'apply.related.item.1.title': '個別相談予約',
  'apply.related.item.1.desc': '無料・オンライン可の相談',
  'apply.related.item.2.title': 'コース一覧・比較',
  'apply.related.item.2.desc': '3コースの違いを一覧で確認',
  'apply.related.item.3.title': '年間スケジュール',
  'apply.related.item.3.desc': '開校時期と授業日程',

  // footer
  'apply.footer.lastUpdated': '最終更新: 2026年6月13日',
  'apply.backToTop.ariaLabel': 'ページの先頭へ戻る',

  // Confirm page
  'apply.confirm.breadcrumb.apply': '申込フォーム',
  'apply.confirm.breadcrumb.current': '確認',
  'apply.confirm.title': 'お申込み内容の確認',
  'apply.confirm.lead': '以下の内容でお間違いなければ、「送信する」をクリックしてください。',
  'apply.confirm.privacyLabel': 'プライバシーポリシー',
  'apply.confirm.privacyAgreed': '同意済み',
  'apply.confirm.editBtn': '修正する',
  'apply.confirm.submitBtn': '送信する',
  'apply.confirm.submitting': '送信中...',
  'apply.confirm.errorDefault': '送信に失敗しました。お手数ですが、再度お試しいただくか、お電話（03-6824-4086）にてお申込みください。',
  'apply.confirm.errorNetwork': '通信エラーが発生しました。ネットワーク接続をご確認のうえ、再度お試しください。',
  'apply.confirm.fields.name': '氏名',
  'apply.confirm.fields.furigana': 'ふりがな',
  'apply.confirm.fields.email': 'メールアドレス',
  'apply.confirm.fields.phone': '電話番号',
  'apply.confirm.fields.desiredCourse': '希望コース',
  'apply.confirm.fields.preferredTerm': '希望開校時期',
  'apply.confirm.fields.transferDiscount': '編入優遇の利用',
  'apply.confirm.fields.motivation': '受講動機',
  'apply.confirm.fields.consultationDesired': '個別相談の希望',
  'apply.confirm.fields.consultYes': '希望する',
  'apply.confirm.fields.consultNo': '希望しない',
  'apply.confirm.fields.empty': '（未入力）',

  // Complete page
  'apply.complete.title': 'お申込みありがとうございます',
  'apply.complete.p1': 'ご入力いただいたメールアドレスに、受付確認の自動返信メールをお送りしました。',
  'apply.complete.p2': '担当者より2営業日以内にご連絡し、受講契約とお支払い（銀行振込）のご案内をお送りします。お振込み確認後に受講確定となります。',
  'apply.complete.coursesBtn': 'コース一覧を見る',
  'apply.complete.homeBtn': 'トップページへ',
};

export default apply;
